import * as excel from 'exceljs';
import { changeDateFormat, workoutDetailsInterface } from "../app/consts";


export const createExcel = (currentWorkout: workoutDetailsInterface) => {
    const date = currentWorkout?.date as string
    const workoutType = currentWorkout?.type?.name as string

    const wk = new excel.Workbook();
    const sheet = wk.addWorksheet("אימון", {
        pageSetup: {
            orientation: currentWorkout?.fullForm ? 'landscape' : 'portrait',
            paperSize: 9,
            fitToPage: true,
            margins: currentWorkout?.fullForm ? {
                bottom: 0,
                top: 0,
                left: 0,
                right: 0,
                footer: 0,
                header: 0
            } : undefined
        },
        views: [{ rightToLeft: true }],
    });

    currentWorkout?.fullForm ? sheet.mergeCells('A1', 'P1') : sheet.mergeCells('A1', 'H1');
    sheet.getCell('A1').value = `אימון ${workoutType} - ${changeDateFormat(currentWorkout?.date as string)}, ${currentWorkout?.time.slice(0, -3)}, ${currentWorkout?.location} - מדריך: ${currentWorkout?.instructor?.fullName === null ? "לא משובץ" : currentWorkout?.instructor?.fullName}`
    sheet.getCell('A1').font = { size: currentWorkout?.fullForm ? 48 : 22 }
    sheet.getRow(1).alignment = { horizontal: 'center', vertical: 'middle' }
    currentWorkout?.fullForm ?
        sheet.getRow(2).values = ["מספר סידורי", "שם מלא", "מספר טלפון", "ת\"ז", "מספר רשיון נשק", "תוקף רשיון", "סוג אקדח", "מספר נשק", "קליבר", "שעת כניסה", "חתימה", "תחמושת", "שעת יציאה", "תשלום", "הערות מתאמן", "סטטוס תשלום", "הערות מנהל"]
        :
        sheet.getRow(2).values = ["מספר סידורי", "שם מלא", "מספר טלפון", "ת\"ז", "קליבר", "הערות מתאמן", "סטטוס תשלום", "הערות מנהל"]


    sheet.getRow(2).font = { size: 16 }
    sheet.getRow(2).eachCell((cell) => {
        cell.border = {
            top: { style: 'thin', color: { argb: '000000' } },
            left: { style: 'thin', color: { argb: '000000' } },
            bottom: { style: 'thin', color: { argb: '000000' } },
            right: { style: 'thin', color: { argb: '000000' } }
        };
        cell.alignment = { horizontal: "center", vertical: "middle" }
    });

    currentWorkout?.fullForm ?
        sheet.columns = [
            {
                key: "id",
                width: 15,
            },
            {
                key: "fullName",
                width: 20,
            },
            {
                key: "phoneNum",
                width: 20,
            },
            {
                key: "participantId",
                width: 20,
            },
            {
                key: "licenseNumber",
                width: 20,
            },
            {
                key: "licenseExpiryDate",
                width: 20,
            },
            {
                key: "pistolType",
                width: 20,
            },
            {
                key: "pistolId",
                width: 20,
            },
            {
                key: "caliber",
                width: 9,
            },
            {
                key: "entryTime",
                width: 20,
            },
            {
                key: "signature",
                width: 20,
            },
            {
                key: "ammunition",
                width: 15,
            },
            {
                key: "exitTime",
                width: 20,
            },
            {
                key: "notes",
                width: 20,
            },
            {
                key: "payment",
                width: 15,
            },
            {
                key: "managerNotes",
                width: 20,
            }

        ]
        :
        sheet.columns = [
            {
                key: "id",
                width: 15,
            },
            {
                key: "fullName",
                width: 20,
            },
            {
                key: "phoneNum",
                width: 20,
            },
            {
                key: "participantId",
                width: 20,
            },
            {
                key: "caliber",
                width: 9,
            },
            {
                key: "notes",
                width: 20,
            },
            {
                key: "payment",
                width: 15,
            },
            {
                key: "managerNotes",
                width: 20,
            }
        ]

    if (currentWorkout?.fullForm as boolean === true) {
        for (let i = 0; i < 5; i++) {
            sheet.addRow({}, "i+")
        }
    }

    currentWorkout?.fullForm ?
        currentWorkout?.participantsList?.map((row, index) =>
            sheet.addRow({
                id: index + 1,
                fullName: row.firstName + " " + row.lastName,
                phoneNum: row.phoneNum,
                participantId: row.personalId,
                licenseNumber: row.licenseNumber,
                licenseExpiryDate: changeDateFormat(row.licenseExpiryDate),
                pistolType: row.pistolType,
                pistolId: row.pistolNumber,
                caliber: row.caliber,
                entryTime: "",
                signature: "",
                ammunition: "",
                exitTime: "",
                notes: row.notes,
                payment: row.isPaid ? "שולם" : "",
                managerNotes: row.adminNotes?.map((note) => note.content).join("\r\n"),
            }, "i+")
        ) :
        currentWorkout?.participantsList?.map((row, index) =>
            sheet.addRow({
                id: index + 1,
                fullName: row.firstName + " " + row.lastName,
                phoneNum: row.phoneNum,
                participantId: row.personalId,
                caliber: row.caliber,
                notes: row.notes,
                payment: row.isPaid ? "שולם" : "",
                managerNotes: row.adminNotes?.map((note) => note.content).join("\r\n"),
            }, "i+")
        );

    sheet.eachRow((row, rowNumber) => {
        row.eachCell((cell, colNumber) => {
            row.getCell(colNumber).alignment = { wrapText: true, vertical: 'middle', horizontal: 'center' };
        });
    });

    wk.xlsx.writeBuffer().then(function (data) {
        const blob = new Blob([data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const url = window.URL.createObjectURL(blob);
        const anchor = document.createElement("a");
        anchor.href = url;
        anchor.download = `אימון ${workoutType} - ${changeDateFormat(date)}.xlsx`;
        anchor.click();
        window.URL.revokeObjectURL(url);
    });
}